import React from 'react'

export const NotFound = () => {
  return <h1>Page Not Found</h1>
}
